export default __webpack_public_path__ + "static/media/sajjat.f2923456.jpg";